// import { lazy } from 'react';
import { AppProvider } from './context/AppContext';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ChatScreen from './component/ChatScreen';
import RoleScreen from './component/RoleScreen';
import VideoScreen from './component/VideoScreen';
import NewsScreen from './component/NewsScreen';

// const RoleScreen = lazy(() => import('./component/RoleScreen'));
// const VideoScreen = lazy(() => import('./component/VideoScreen'));
// const ChatScreen = lazy(() => import('./component/ChatScreen'));

const router = createBrowserRouter([
  {
    path: '/',
    element: <RoleScreen />,
  },
  {
    path: '/chat',
    element: <ChatScreen />,
  },
  {
    path: '/video',
    element: <VideoScreen />,
  },
  {
    path: '/news',
    element: <NewsScreen />,
  },
]);

function App() {
  return (
    <div className="w-screen root-bg min-h-screen h-fit">
      <AppProvider>
        <RouterProvider router={router}></RouterProvider>
        <ToastContainer />
      </AppProvider>
    </div>
  );
}

export default App;
